module.exports = __webpack_public_path__ + "static/finalprod-33bab1b38bf3c738f38a277ef7dd1705.png";